import './style/index.css';

import AppRouter from '@/router';

import StyleProvider from './components/StyleProvider';
import Migration from './components/Migration';

// import "@/log/index";
function MyApp() {

  return (
    <div className="MyApp">
      <StyleProvider >
        {/* 迁移弹窗 */}
        <Migration />
        <AppRouter />
      </StyleProvider>
    </div>
  );
}

export default MyApp;
